import Box from '@mui/material/Box';
import React from 'react';
import HalfSizeBanner from '../components/Banners/HalfSizeBanner';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Cards from '../components/Cards/Cards';
import Accordions from '../components/Accordions/Accordions';
import SmallCards from '../components/Cards/SmallCards';
// import { Link } from 'react-router-dom';
import TextBtnSection from '../components/Section/TextBtnSection';
import ContentCard from '../components/Cards/ContentCard';
import BigCard from '../components/Cards/BigCard';
import { useTranslation } from '../hook/Translation';

export default function HybridLaserSerum() {
const { t } = useTranslation();
    const data = [
        {
            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2025/12/Mask Group 17.png`,
            header: 'Face',
            description: "Rejuvenates the skin's surface and deeper layers simultaneously. Smooths fine lines, reduces pores, fades scars, and restores an even, refined glow.",
            buttonText: 'LEARN MORE',
            buttonUrl: '/'
        },
        {
            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2025/12/Mask Group 18.png`,
            header: 'Scars & Stretch Marks',
            description: 'Targets irregular texture and tone caused by scars or stretch marks, stimulating new collagen for visibly smoother skin.',
            buttonText: 'LEARN MORE',
            buttonUrl: '/'
        },
        {
            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2025/12/Mask Group 19.png`,
            header: 'Neck & Décollete',
            description: 'Revitalize thin, sun-exposed skin with dual-laser precision. Smooths lines, evens tone, and restores firmness while preserving softness and natural texture.',
            buttonText: 'LEARN MORE',
            buttonUrl: '/'
        }
    ]

    const accodirons = [
        {
            title: 'What it is?',
            content: 'Dual-wavelength fractional resurfacing (CO₂ + 1570 nm) with immediate trans-epidermal serum infusion.'
        },
        {
            title: 'How it works',
            content: 'CO₂ creates controlled microchannels and removes damaged tissue. The 1570 nm laser heats the dermis to stimulate collagen. Medical serums are then infused through fresh channels to support repair and hydration.'
        },
        {
            title: 'Benefits',
            content: 'Refined texture and tone, softer lines and scars, brighter skin. Faster recovery than aggressive full-field CO₂ alone, with added nourishment.'
        },
        {
            title: 'Areas',
            content: 'Face and neck, and selected body areas for scars or stretch marks.'
        },
        {
            title: 'Pairs with other treatments',
            content: 'Can stand alone. Can also be combined with Fractional CO₂ or Non-Ablative Erbium Glass for layered rejuvenation, or used post-procedurally to support healing after resurfacing.'
        },
        {
            title: t('downtime'),
            content: 'Redness and mild swelling for 1 to 3 days, followed by light dryness or flaking. Barrier care and SPF required.'
        },
        {
            title: 'Results timeline',
            content: 'Visible glow within the first week. Ongoing collagen improvement over the next several weeks.'
        },
    ];

    const data2 = [
        {
            imageUrl: '/images/fractional/hourglass-end.svg',
            title: t('time'),
            description: '45 to 75 min'
        },
        {
            imageUrl: '/images/fractional/headache.svg',
            title: t('discomfort'),
            description: 'Moderate'
        },
        {
            imageUrl: '/images/fractional/duration.svg',
            title: t('downtime'),
            description: 'Light, 2 to 4 days'
        },
        {
            imageUrl: '/images/fractional/facial-treatment.svg',
            title: t('sessions'),
            description: '1 to 3'
        }
    ];

    return (
        <Box>

            <Box>
                <HalfSizeBanner>
                    <Box height={'100%'} bgcolor={'#1E353D'}>
                        <Box component={'img'} src={`${process.env.REACT_APP_SITE_URL}/images/2025/12/Screenshot 2025-11-04 at 1.25.45 PM_long.png`} height={1} width={1} className='fitCover' />
                    </Box>
                </HalfSizeBanner>
            </Box>

            <Box className="generalContainer" marginX={'auto'} marginTop={{ md: '80px', xs: '50px' }}>
                <TextBtnSection 
                    data={{
                        type: t('skinTherapies'),
                        title: "Hybrid Laser + Serum Infusion",
                        description: "Intensive resurfacing plus deep nourishment. This advanced therapy combines the power of two laser wavelengths in one session: an ablative laser for resurfacing and a non-ablative laser for dermal rejuvenation followed by a transdermal serum infusion for maximum skin benefit.",
                        bookUrl: '/'
                    }} 
                />
            </Box>

            <Box marginTop={{ md: '132px', xs: '50px' }}>
                <Box component={'img'} src='/images/fractional/Path 134.svg' width={1} sx={{ objectFit: 'cover' }} />
            </Box>

            <Box>
                <Box marginTop={{ md: '104px', xs: '50px' }} className='generalContainer' marginX={'auto'}>
                    <SmallCards data={data2} />
                </Box>
            </Box>

             <Box sx={{ width: { xl: '1340px', xs: '90%' }, marginX: 'auto' }} marginTop={{ md: '90px', xs: '50px' }}>
                <Box sx={{ height: {md: 440, xs: 'auto'} }}>
                    <BigCard
                        data={{
                            height: {md: 460, xs: 1},
                            type: 'Technology',
                            title: 'Trans-Epidermal Delivery',
                            descriptionSize: 12,
                            size: { md: 6.3, xs: 12 },
                            imageSize: {md: 5.7, xs: 12},
                            btnContainer: { md: 12, xs: 12 },
                            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2025/27/Mask Group 8.png`,
                            flexDirection: {md: 'row-reverse', xs: 'row'},
                            description: 'After laser, we utilize a special Trans-Epidermal Delivery technology to push a customized cocktail of serums (rich in peptides, vitamins, and hyaluronic acid) through those micro-channels . This deeply nourishes the fresh laser-treated skin, amplifying hydration and collagen benefits beyond what laser alone can do.',
                            book: '/'
                        }}
                        extraStyle={{
                            background: 'linear-gradient(90deg,rgba(30, 53, 61, 1) 0%, rgba(30, 53, 61, 1) 35%, rgba(30, 53, 61, 1) 50%, rgba(30, 53, 61, 1) 100%)'
                        }}
                        bgColor={'unset'}
                    />
                </Box>
            </Box>

            <Grid container gap={{md: '20px', xs: '40px'}} className="generalContainer" sx={{ marginX: 'auto', marginTop: {md: '80px', xs: '50px'} }}>
                <Grid size={12}>
                    <Typography textAlign={'center'} variant="body1" color="text.secondary" fontSize={'1.125rem'} fontWeight={'bold'}>Treatment Areas</Typography>
                    <Typography textAlign={'center'} marginX={'auto'} width={{ md: '80%', xs: '100%' }} variant="body1" color="text.secondary" fontSize={'1rem'} marginTop={'20px'}>Suitable for face, neck, décolleté, and body zones affected by scars, stretch marks, or photodamage. Alma Hybrid combines fractional CO and 1570 nm laser energy to resurface skin, refine texture, and stimulate collagen remodeling with precise control over depth and recovery.</Typography>
                </Grid>
                <Grid size={12}>
                    <Cards data={data} imageHeight={'340px'} headerAlign={'center'} descriptionAlign={'center'} buttonAlign={'auto'} sizes={{ xs: 12, sm: 6, md: 6, lg: 4 }} />
                </Grid>
            </Grid>

            <Grid container gap={{md: '80px', xs: '40px'}} className="generalContainer" sx={{ marginX: 'auto', marginTop: {md: '156px', xs: '50px'} }}>
                <Grid size={12}>
                    <Typography textAlign={'center'} variant="body1" color="text.secondary" fontSize={'1.125rem'} fontWeight={'bold'}>Additional Information</Typography>
                </Grid>
                <Grid size={12}>
                    <Accordions data={accodirons} />
                </Grid>
            </Grid>
            <Box bgcolor={'#DBDAD9'} marginTop={{md: '80px', xs: '50px'}} paddingTop={{md: '120px', xs: '50px'}} paddingBottom={{md: '188px', xs: '50px'}}>
                

                <Box className="generalContainer" marginX={'auto'} gap={{md: '89px', xs: '50px'}} display={'flex'} flexDirection={'column'}>
                    <ContentCard
                        data={{
                            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2025/12/laser-alma-hybrid-2024-skinmed-clinic.png`,
                            type: 'Pairing',
                            title: 'Fractional CO₂',
                            description: 'Alma Hybrid complements Fractional CO₂ in staged rejuvenation plans. The initial Fractional CO₂ session provides deep ablation and collagen remodeling, while the subsequent Hybrid + Infusion treatment refines texture, evens tone, and accelerates healing through controlled non-ablative energy and targeted serum delivery. Together they achieve smoother, brighter, and more uniform skin with balanced recovery.',
                            direction: { md: 'row-reverse', xs: 'row' },
                            learn: "/skin/fractional-co2-resurfacing",
                            book: '/'
                        }}
                        heigth={{ md: '440px', xs: 'auto' }}
                    />

                    <ContentCard
                        data={{
                            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2025/12/Alma_Co2.png`,
                            type: 'Pairing',
                            title: 'Erbium Glass',
                            description: 'When combined with non-ablative Erbium Glass sessions, Alma Hybrid enhances long-term dermal renewal. Erbium Glass stimulates collagen production with minimal downtime, and the Hybrid + Infusion treatment later reinforces these results by resurfacing the upper layers and restoring luminosity. The synergy provides progressive tightening, refined pores, and improved skin quality over time.',
                            learn: "/skin/hybrid-laser-erbium-glass",
                            book: '/'
                        }}
                        heigth={{ md: '440px', xs: 'auto' }}
                    />
                </Box>

            </Box>


        </Box>
    )
}